module.exports = __webpack_public_path__ + "static/deliveroo@2x-21cd0f4b870cc38b2f5b9a413beccbac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/deliveroo@2x.jpg
// module id = 867
// module chunks = 33019919093843 122353984331245